import { CSSProperties, useEffect, useState } from "react";
import { SelectProps } from "antd";
import clsx from "clsx";
import { components } from "@entities/journal";
import { useResetState } from "@shared/lib/hooks";
import { SignerSuggestions } from "../signers-suggestions";
import { DropdownLoader } from "./dropdown-loader.tsx";

import "./user-infinite-scroll.scss";

type Signer = components["schemas"]["SignerInfo"];

interface SignersScrollProps extends SelectProps {
  titleId: string;
  onSignerSelect: (signer: Signer) => void;
  style?: CSSProperties;
  className?: string;
  defaultValue?: string;
  users: any;
}

export function SignersScroll({
  titleId,
  onSignerSelect,
  style,
  className,
  defaultValue,
  users,
  ...rest
}: SignersScrollProps) {
  const [defaultValueLocked, setDefaultValueLocked] = useState(false);

  const { key, reset } = useResetState();

  useEffect(() => {
    if (!defaultValueLocked && defaultValue) {
      reset();
      setDefaultValueLocked(true);
    }
  }, [defaultValue, reset]);

  return (
    <SignerSuggestions
      key={key}
      defaultValue={defaultValue}
      showSearch={false}
      className={clsx("user-infinite-scroll", className)}
      style={style}
      popupMatchSelectWidth
      placement="bottomLeft"
      users={users}
      onSignerSelect={onSignerSelect}
      dropdownRender={(menu) =>
        DropdownLoader({
          menu,
        })
      }
      {...rest}
    />
  );
}
